import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { LOGIN_ROUTE } from '../../constants';

export default class Logout extends PureComponent {
  static propTypes = {
    requestLogout: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { requestLogout, history } = this.props;
    requestLogout();

    history.push(LOGIN_ROUTE);
  }

  render() {
    return false;
  }
}
